   <div class="container-session">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Users by platform</mat-card-title>
          <div class="dashboard-header-filters">
            <mat-form-field appearance="outline" class="time-range-select">
              <mat-label>Time Range</mat-label>
              <mat-select panelClass="um-select-panel" [(ngModel)]="timeRange" (selectionChange)="onTimeRangeChange($event)">
                <mat-option value="day">Day</mat-option>
                <mat-option value="week">Week</mat-option>
                <mat-option value="month">Month</mat-option>
                <mat-option value="custom">Custom</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="timeRange === 'custom'">
              <mat-form-field appearance="outline" class="custom-date-field">
                <input matInput [owlDateTime]="startPicker" [owlDateTimeTrigger]="startPicker" placeholder="Start Date" [(ngModel)]="startDate" (dateTimeChange)="onCustomDateChange()">
                <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
                <owl-date-time #startPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
              </mat-form-field>
              <mat-form-field appearance="outline" class="custom-date-field">
                <input matInput [owlDateTime]="endPicker" [owlDateTimeTrigger]="endPicker" placeholder="End Date" [(ngModel)]="endDate" (dateTimeChange)="onCustomDateChange()">
                <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
                <owl-date-time #endPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
              </mat-form-field>
            </ng-container>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div *ngIf="loading" class="spinner-container">
            <mat-spinner class="custom-spinner" [diameter]="50"></mat-spinner>
          </div>
          <div *ngIf="true">
            <canvas id="loginFrequencyChart"></canvas>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
